import * as React from 'react';
import { SelectionTypeProps } from '../../types';
import { SelectionType } from '../../types-fields';
import { isPositiveNumeric } from 'app/infrastructure/data/number';
import { Validation, ValidationLevel } from 'ui';
import { defaultIntervalValue } from 'app/area/reports/constants';
import { RadioSymbol } from 'ui';

import type { JSX } from "react";

type IntervalComponentProps = SelectionTypeProps
interface IntervalComponentState {
  validated: boolean;
}
class IntervalComponent extends React.Component<IntervalComponentProps, IntervalComponentState> {
  public state: Readonly<IntervalComponentState> = {
    validated: false
  };

  private handleOnChange = () => {
    const {
      selectionField: {
        value
      }
    } = this.props;
    this.props.onChange({
      ...value,
      interval: !!value.interval ? value.interval : defaultIntervalValue,
      type: SelectionType.Interval
    });
  };

  private handleInputOnChange = (value: number) => {
    this.props.onChange({
      ...this.props.selectionField.value,
      interval: value
    });
  };

  private onChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    if (isPositiveNumeric(value)) {
      this.handleInputOnChange(parseInt(value, 10));
    } else if (typeof value === 'string' && value.trim() === '') {
      this.handleInputOnChange(undefined);
    } else {
      this.handleInputOnChange(this.props.selectionField.value.interval);
    }
  };

  public render(): JSX.Element {
    const {
      selectionField: {
        value
      },
      selectionItem,
      checked,
      translation
    } = this.props;
    const isValid = !!value.interval;
    const uniqueId = `interval-${this.props.selectionField?.selectionNo}`;
    return (
      <div>
        <input
          type="radio"
          className="form-check-input visuallyhidden"
          id={uniqueId}
          value={value.type}
          checked={checked}
          onChange={this.handleOnChange}
        />
        <label
          className="form-check-label"
          htmlFor={uniqueId}>
          <RadioSymbol/>
          {selectionItem.label}
        </label>
        {!!checked && <div className={isValid ? '' : 'has-danger'}>
          <div className="input-wrapper">
            <input
              className="form-control"
              type="text"
              onChange={this.onChange}
              value={!!value.interval ? value.interval : ''}
            />
          </div>
          {!isValid && <Validation level={ValidationLevel.error}
            messages={[
              {
                level: ValidationLevel.error,
                message: translation.group_by_interval_value_not_valid
              }]} />}
        </div>}
      </div>
    );
  }
}

export const Interval = IntervalComponent;
